import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-refresh-snackbar',
  imports: [MatButtonModule, MatIconModule],
  template: `
    <div class="bg-card flex w-full items-start gap-4">
      <div
        class="flex h-10 w-10 flex-0 items-center justify-center rounded-full bg-accent"
      >
        <mat-icon
          class="text-white icon-size-6"
          [svgIcon]="'heroicons_outline:arrow-path'"
        ></mat-icon>
      </div>
      <div class="flex flex-col items-start gap-4">
        <div class="flex flex-col">
          <span class="text-default text-base font-medium leading-5">
            Your session data needs to be refreshed.
          </span>
          <span
            class="text-default text-[0.8125rem] leading-[1.125rem] opacity-80"
          >
            Would you like to do it now? It will only take a few seconds.
          </span>
        </div>
        <div class="flex w-full justify-end gap-2">
          <button mat-stroked-button class="min-w-28" (click)="dismiss()">
            Cancel
          </button>
          <button
            mat-flat-button
            class="min-w-28"
            color="accent"
            (click)="refresh()"
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      /* A6: the snackbar stays where it is designed to be — top right — but
         the pane around the card used to take pointer events across the whole
         strip, so even the header next to the card was unclickable. The pane is
         transparent to clicks now and only the card itself takes them. */
      .cdk-overlay-pane:has(> .refresh-snackbar) {
        pointer-events: none;
      }

      .refresh-snackbar {
        pointer-events: auto;

        .mat-mdc-snackbar-surface {
          @apply bg-card max-w-100 p-4 #{'!important'};
        }
        .mdc-snackbar__label {
          @apply p-0 #{'!important'};
        }
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class RefreshSnackbarComponent {
  private snackBarRef = inject(MatSnackBarRef<RefreshSnackbarComponent>);

  refresh(): void {
    this.snackBarRef.dismissWithAction();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
